export enum IdentityProviderType {
  AWS_COGNITO = 'AwsCognito',
  ECORRIDOR = 'Ecorridor',
  KEYCLOAK = 'Keycloak',
}
